import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
	iconContainer: {
		display: 'flex',
		justifyItems: 'center',
		alignContent: 'center',
	},
	icon: {
		width: 30,
		height: 30,
		[theme.breakpoints.down('sm')]: {
			width: 18,
			height: 18,
		},
	},
}));
